module.exports = __webpack_public_path__ + "img/logo_la_maison_de_l_entreprise.6c5f6dd5.png";